
const callRecordMoudle={
  namespaced: true,
  state:{
    searchSN:'',
    model:'',
  },
  mutations:{

  },
  getters:{

  },
  actions:{

  }
};

export default callRecordMoudle;



// WEBPACK FOOTER //
// ./src/store/moudles/callRecord.js